import { render } from "./PasswordStatus.vue?vue&type=template&id=52ccf0aa&ts=true"
import script from "./PasswordStatus.vue?vue&type=script&lang=ts"
export * from "./PasswordStatus.vue?vue&type=script&lang=ts"

import exportComponent from "/private/var/folders/7t/359t2n_s4j10v1mvcf5z597r0000gn/T/deploy/auth-ui/3ff40db5e0ea13b269191a4752930385caf51f95/node_modules/.pnpm/vue-loader@17.0.1_@vue+compiler-sfc@3.4.35_vue@3.4.35_typescript@5.4.3__webpack@5.93.0_webpack-cli@5.1.4_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__